import { getAvatarColorWithName, isValidAvatarUrl } from '@/utils/helper'
import { Box, Typography, useTheme } from '@mui/material'
import { useMemo } from 'react'

interface AvatarProps {
  url?: string
  name: string
  size?: number
  width?: number
  height?: number
  borderRadius?: number
  className?: string
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

export function UserAvatar({
  url,
  name,
  size = 36,
  borderRadius = 100,
  className = 'avatar',
  width,
  height,
  style,
  onClick = () => {},
}: AvatarProps) {
  const { palette } = useTheme()
  const initials = useMemo(() => {
    const [firstName = '', lastName = ''] = name.split(' ')

    return `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase()
  }, [name])

  // const isValidURL = url?.length ? isValidAvatarUrl(url!) : false
  const isValidURL = url?.length ? isValidAvatarUrl(url!) : false
  const resolvedWidth = width || size
  const resolvedHeight = height || size

  const commonStyles = {
    width: resolvedWidth,
    height: resolvedHeight,
    borderRadius,
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.15)',
      zIndex: 2,
    },
    ...style,
  }

  return (
    <Box
      className={className}
      display='flex'
      justifyContent='center'
      alignItems='center'
      onClick={onClick}
      bgcolor={isValidURL ? 'transparent' : getAvatarColorWithName(name)}
      sx={commonStyles}
    >
      {isValidURL ? (
        <img
          src={url}
          alt={name}
          width={resolvedWidth}
          height={resolvedHeight}
          // onError={() => setImgError(true)}
          style={{
            objectFit: 'cover',
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius,
          }}
        />
      ) : (
        <Typography fontSize={size / 3} fontWeight={600} color='white'>
          {initials}
        </Typography>
      )}
    </Box>
  )
}
